import { createRequestTypes } from '../utils';

export const AUTHENTICATE = createRequestTypes('user/AUTHENTICATE');
export const LOGOUT = 'user/LOGOUT';
